
import styled from 'styled-components';

export const Container = styled.div`
    margin: auto;
    width: 80%;
    
    .filter {
        margin-bottom: 3rem;
        display: flex;

        > div {
            width: 30rem;
            padding: 0;
            margin: 0;
        }
    }

    table {
        width: 100%;
    }

    

    @media screen and (max-width: 576px){
        width: 100%;
        padding: .5rem;
    }
`;